import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  active: {
    id: 'studio.3a5wL8',
    defaultMessage: 'Active',
  },
  limitedApps: {
    id: 'studio.0tiuZn',
    defaultMessage: 'Amount of apps you can publish:',
  },
  unlimitedApps: {
    id: 'studio.Oxz/Q0',
    defaultMessage: 'You can publish unlimited apps',
  },
  emailQuota: {
    id: 'studio.PK/9+W',
    defaultMessage: 'Daily email quota:',
  },
  containers: {
    id: 'studio.YV2RwU',
    defaultMessage: 'Custom containers',
  },
  communitySupport: {
    id: 'studio.PuiVTe',
    defaultMessage: 'Community support',
  },
  professionalSupport: {
    id: 'studio.sSY9Qn',
    defaultMessage: 'Professional support',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  switch: {
    id: 'studio.n1Whvj',
    defaultMessage: 'Switch',
  },
  extend: {
    id: 'studio.BLAy25',
    defaultMessage: 'Extend',
  },
  sla: {
    id: 'studio.5W7LEp',
    defaultMessage: 'SLA',
  },
  blocks: {
    id: 'studio.+im1ZA',
    defaultMessage: 'Blocks',
  },
  unlimitedNotifications: {
    id: 'studio.Sy2Vyb',
    defaultMessage: 'Unlimited notifications',
  },
  limitedNotifications: {
    id: 'studio.RVlg8a',
    defaultMessage: 'Daily notifications',
  },
  storage: {
    id: 'studio.DUIDEq',
    defaultMessage: 'Storage',
  },
  expirationDate: {
    id: 'studio.2ukWZT',
    defaultMessage: 'Expires on ',
  },
});
